import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingServiceService {

  private loadingSubject = new BehaviorSubject<boolean>(false);
  private loadingCounter = 0;
  loading$ = this.loadingSubject.asObservable();

  constructor() { }

  show(): void{
    this.loadingCounter++;
    this.loadingSubject.next(true);
  }

  hide():void{
    this.loadingCounter--;
    if(this.loadingCounter <= 0){
      this.loadingCounter = 0;
      this.loadingSubject.next(false);
    }
  }

}
